var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuditorium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4986_5750",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4986_5750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.52083 6.20833C4.36806 6.02778 4.25361 5.83333 4.1775 5.625C4.10083 5.41667 4.0625 5.19444 4.0625 4.95833C4.0625 4.38889 4.2675 3.89944 4.6775 3.49C5.08694 3.08 5.57639 2.875 6.14583 2.875C6.72917 2.875 7.22222 3.08 7.625 3.49C8.02778 3.89944 8.22917 4.38889 8.22917 4.95833C8.22917 5.19444 8.19444 5.41667 8.125 5.625C8.05556 5.83333 7.94444 6.02778 7.79167 6.20833H4.52083ZM8.5 17.125C7.73611 17.125 7.08333 16.8542 6.54167 16.3125C6 15.7708 5.72917 15.1181 5.72917 14.3542H5.10417L4.35417 7.125H7.95833L7.20833 14.3542H6.5625C6.5625 14.8958 6.75333 15.3542 7.135 15.7292C7.51722 16.1042 7.97222 16.2917 8.5 16.2917C9.02778 16.2917 9.47917 16.1008 9.85417 15.7192C10.2292 15.3369 10.4167 14.8819 10.4167 14.3542V5.64583C10.4167 4.88194 10.6875 4.22917 11.2292 3.6875C11.7708 3.14583 12.4167 2.875 13.1667 2.875C13.9306 2.875 14.5833 3.14583 15.125 3.6875C15.6667 4.22917 15.9375 4.88194 15.9375 5.64583V17.125H15.1042V5.64583C15.1042 5.11806 14.9133 4.66306 14.5317 4.28083C14.1494 3.89917 13.6944 3.70833 13.1667 3.70833C12.6389 3.70833 12.1875 3.89917 11.8125 4.28083C11.4375 4.66306 11.25 5.11806 11.25 5.64583V14.3542C11.25 15.1181 10.9792 15.7708 10.4375 16.3125C9.89583 16.8542 9.25 17.125 8.5 17.125ZM5.83333 13.5208H6.45833L7.02083 7.95833H5.29167L5.83333 13.5208Z",
    fill: "#151515"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditorium);
export default __webpack_public_path__ + "static/media/Auditorium.af0f79f1b67406f9e2e0eb49c74b1094.svg";
export { ForwardRef as ReactComponent };